
<button *ngIf="show" class="btn" data-toggle="tooltip" [disabled]="!enabled"
        [ngClass]="is_small ? 'btn-small' : 'btn-transparent'"
        title="{{ btn_tooltip | locale}}"
        (click)="onClicked($event)">
  <i  (click)="onClicked($event)" class="fas fa-{{btn_icon}}" aria-hidden="true" style="font-size: 14px;"></i>
</button>